import React from "react";
import { Tabs, Tab, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

const OrderTypeTabs = ({
  value,
  onChange,
  currentPrice,
  handlePriceChange,
  handleTriggerChange,
  radioTypeOptions,
}) => {
  const theme = useTheme();

  const onTabChange = (e, newValue) => {
    onChange(newValue);
    switch (newValue) {
      case "MARKET":
        handlePriceChange({ target: { value: "0" } });
        handleTriggerChange({ target: { value: "0" } });
        break;
      case "STOPLOSSMARKET":
        handlePriceChange({ target: { value: "0" } });
        handleTriggerChange({ target: { value: currentPrice?.toString() || "0" } });
        break;
      case "SL":
        handlePriceChange({ target: { value: currentPrice?.toString() || "0" } });
        handleTriggerChange({ target: { value: currentPrice?.toString() || "0" } });
        break;
      case "LIMIT":
        handlePriceChange({ target: { value: currentPrice?.toString() || "0" } });
        handleTriggerChange({ target: { value: "0" } });
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontWeight: 600, textTransform: "uppercase", letterSpacing: 1 }}
      >
        Order Type
      </Typography>
      <Tabs
        value={value}
        onChange={onTabChange}
        variant="fullWidth"
        sx={{
          "& .MuiTabs-flexContainer": {
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            borderRadius: 3,
            p: 0.25,
          },
          "& .MuiTabs-indicator": { display: "none" },
        }}
      >
        {radioTypeOptions.map((option) => (
          <Tab
            key={option.value}
            value={option.value}
            disableRipple
            sx={{
              borderRadius: 2,
              fontSize: "0.7rem",
              minHeight: 32,
              height: 32,
              padding: "4px 8px",
              color:
                value === option.value
                  ? "#FFFFFF !important"
                  : theme.palette.text.primary,
              backgroundColor:
                value === option.value
                  ? (() => {
                      switch (option.value) {
                        case "MARKET":
                          return theme.palette.success.main;
                        case "LIMIT":
                          return theme.palette.success.dark;
                        case "SL":
                          return theme.palette.success.main;
                        case "STOPLOSSMARKET":
                          return theme.palette.success.dark;
                        default:
                          return theme.palette.success.main;
                      }
                    })()
                  : "transparent",
              "&:hover": {
                backgroundColor:
                  value === option.value
                    ? theme.palette.success.main
                    : alpha(theme.palette.primary.main, 0.2),
                color: "#FFFFFF !important",
              },
            }}
            label={
              option.value === "MARKET"
                ? "Market"
                : option.value === "LIMIT"
                ? "Limit"
                : option.value === "SL"
                ? "SL"
                : option.value === "STOPLOSSMARKET"
                ? "SL Market"
                : option.label
            }
          />
        ))}
      </Tabs>
    </>
  );
};

export default OrderTypeTabs;


